import type { ReactNode } from 'react';

type NavBarContainerV2Props = {
  children: ReactNode;
};

const NavBarContainerV2 = ({ children }: NavBarContainerV2Props) => {
  return (
    <div
      className="flex flex-col h-full w-full min-w-full lg:mx-4 lg:bg-color-white rounded-t-2xl relative py-4 px-2 shadow-sm border-l-4"
      style={{ borderLeftColor: '#4298b5' }}
    >
      {children}
    </div>
  );
};

export default NavBarContainerV2;
